import { Subject } from "rxjs";

export class HtmlConvertor {
    constructor(){}
    pdf = new Subject();
    image = new Subject();
    async parse(html:string, parentStyle: defaultStyle) {
      return this.parseContainerElement(await this.innerHTMLtoElement(html), parentStyle);
    }
  
    async innerHTMLtoElement(s:string):Promise<HTMLElement>{
      let a = document.createElement('div');
      a.setAttribute('id', 'uniqueString');
      a.innerHTML = s;
      a.style.display = 'none';
      document.body.appendChild(a);
      let b = document.getElementById('uniqueString');
      document.body.removeChild(a);
      return b as HTMLElement;
    }
  
    async parseContainerElement(html : HTMLElement, parentStyle){
      // console.log(html, html.childNodes)
      let outputArray = [];
      // html is a container element that should be returned as a stack
      for(var i = 0; i < html.childNodes.length; i++){
        // get type of element (text node or other)
        // if other, then extract style and overwrite parentStyle
        let node = await this.parseNode(html.childNodes[i], parentStyle, false);
        if(node != 'ignore') outputArray.push(node);
      }
      return outputArray
    }
  
    async parseNode(n:any, parentStyle, isList){
      let childStyle = {...parentStyle};
      if(isList && n.textContent.startsWith('\n')) return 'ignore';
      // Is the node an unordered list within a unorderlist, then set list type to circle.
      if(n.nodeName.toLowerCase() == 'ul' &&  n.parentNode.nodeName.toLowerCase() == 'li') childStyle.listType = 'circle';
      switch(n.nodeName){
        case '#text':{
          // Should inherit parentStyle
          return !n.textContent.startsWith('\n') && !isList ? {text:n.textContent, ...parentStyle} : 'ignore'
        }
        case '#comment': {
          return { text:'', pageBreak: 'before' }
          break
        }
        case 'BR': {
          return '\n'
        }
        case 'TABLE': {
          // Table always have a tbody.
          let a = await this.parseTableNode(n.children[0], childStyle, isList);
          return a
        }
        default : {
          // console.log(n)
          // if(n.nodeName == 'P' && n.textContent.trim() == '') return 'ignore'
          let children = [];
          if(!!n.childNodes && n.childNodes.length == 1 && n.childNodes[0].nodeName == '#comment' && n.childNodes[0].textContent.includes('pagebreak')){
            return { text:'', pageBreak:'before' }
          }
          childStyle = this.mergeStyles(childStyle, this.childStyle(n, parentStyle), this.tagStyle(n))
          for(var i = 0; i < n.childNodes.length; i++){
            // get type of element (text node or other)
            // if other, then extract style and overwrite parentStyle
            let childNode = await this.parseNode(n.childNodes[i], childStyle, ['ul','ol'].includes(n.nodeName.toLowerCase()))
            if(childNode != 'ignore') children.push(childNode);
          }
          // If within a list and a list item contains another list, it must be returned as a stack, not a text.
          if(isList && n.nodeName.toLowerCase() == 'li' && this.childNodesContainsList(n)) {
            return this.returnTypeByTag('stack', children, childStyle, n)
          }
          else {
            return this.returnTypeByTag(n.nodeName.toLowerCase(), children.length == 1 && typeof(children[0]) == 'string' ? children[0]:children, childStyle, n)
  
          }
        }
      }
    }
    
    async parseTableNode(n:any, parentStyle, isList){
      /**
       * Node -> TR.forEach -> TD -> parseNode
       * TBODY can be ignored
       * Table widths on the page need to be calculated
       */
      let output = [];
      let rowCount = n.children.length;
      let colCount = n.children[0].children.length;
      let widths = this.colWidthsFromTinyTable(n);
      let useBorders = n.border == '1' ? 'lightHorizontalLines' : 'noBorders';
      // console.log({rows:rowCount, cols:colCount, widths:widths, name:n.nodeName})
      for(let x of n.children) {
        let tr = await this.tableRow(x, parentStyle, isList);
        output.push( tr );
      }
      return {
        table:{
          body: output,
          widths: widths
        },
        layout: useBorders
      }

    }

    async tableRow(tr, parentStyle, isList){
      let row = [];
      let node;
      for(let x of tr.children){
        if(x.children.length != 1){
          node = await this.parseNode(x, parentStyle, isList);
        }
        else {
          node = await this.parseNode(x.children[0], parentStyle, isList)
        }
        row.push(node);
      }
      return row
    }

    colWidthsFromTinyTable(n){
      let a = Array.from(n.children[0].children) as HTMLElement[];
      return a.map(x => x.style['width'])
    }

    returnTypeByTag(tag, children, childStyle, node){
      // if(tag == 'td') console.log(children, node, node.childNodes)
      switch(tag){
        case 'ul' : return { ul: children, ...childStyle, margin:[0,5,0,5] }
        case 'ol' : return { ol: children, ...childStyle, margin:[0,5,0,5] }
        case 'h1' :
        case 'h2' :
        case 'h3' : 
        case 'h4' : return { text:children, ...childStyle, margin:[0,5,0,5]}
        case 'li' : return { text: children, ...childStyle } 
        case 'p' : {
          // if paragraph only incldues image, return as stack
          if(node.children.length == 1 && node.children[0].nodeName == 'IMG') return { stack:[children[0]], ...childStyle }
          return { text: children, ...childStyle, margin:[0,0,0,5] }
        }
        case 'td': return { columns:[ children ], ...childStyle } 
        case 'div':
        case 'stack' : return { stack: [children], ...childStyle }
        case 'img' : {
          // Image src needs to be parsed in order to put it into the image object.
          let src = node.src.replace('https://jubloapi.azure-api.net/api/shared/attachments/','').split('?userId')[0];
          this.image.next(src)
          return { image: src, fit:[node.width * 0.75292857248934, node.height * 0.75292857248934]}
        }
        case 'a': return { text: children, link: node.href, color:'blue', decoration:'underline'}
        default : return { text: children, ...childStyle }
      }
    }
  
    childNodesContainsList(n:Node){
      return !!Array.from(n.childNodes).map(x => x.nodeName).find(x => x == 'UL' || x == 'OL' || x == 'BR')
    }
  
    childStyle(element, parentStyle):object{
      let val = {}
      if(!element.style) return val
      for(var i = 0; i < element.style.length; i++) {
        switch(element.style[i]){
          case 'text-decoration-line': {val['decoration'] = 'underline';break}
          case 'list-style-type': {val['listType'] = element.style['list-style-type'];break}
          case 'font-size': {
            let size = element.style['font-size'];
            if(size.includes('px')) val['fontSize'] = Math.round(+size.replace('px','') * 0.75292857248934  )
            else if(size.includes('pt')) val['fontSize'] = +size.replace('pt','')
            else if(size.includes('%')) {
              if(!!parentStyle.fontSize) val['fontSize'] = ((+size.replace('%','')) / 100 ) * parentStyle.fontSize
              else val['fontSize'] = ((+size.replace('%','')) / 100 ) * 10
            };
            break
          }
          case 'line-height' : { 
            console.log('line height: ', element.style['line-height'])
            val['lineHeight'] = !!+element.style['line-height'] ? element.style['line-height'] : null;break 
          }
          case 'color': { 
            console.log('Color: ',element.style.color)
            if(!element.style['color'].includes('rgb')) val['color'] = element.style['color']; 
            break 
          }
          case 'margin-left': { console.log(element) }
          default : {}
        }
      }
      return {...val}
    }
  
    tagStyle(tag){
      switch(tag.nodeName.toLowerCase()){
        case 'em': return { italics: true };
        case 'strong':
        case 'b' : return { bold: true };
        case 'a' : return { link: tag.href };
        case 'h2': return { fontSize: 16, bold:true };
        case 'h3': return { fontSize: 12, bold:true };
        case 'h4': return { fontSize: 10, bold:true };
        case 'p' : return { margin:[0,0,0,10] }
        default : return {}
      }
    }
  
    mergeStyles(p,c,t){
      /**
       * TODO
       * Return object without keys with null values for readibility.
       */
      let start = p;
      Object.keys(t).forEach(x => start[x] = t[x]);
      Object.keys(c).forEach(x => start[x] = c[x]);
      return start
    }
  }

  interface defaultStyle {
    fontSize?: number;
    bold?: boolean;
    color?: string;
    italics?: boolean;
    lineHeight?: number;
    margin?: [number, number, number, number];
    text?: string;
    width?: number | '*' | 'auto';
    alignment?: 'left' | 'center' | 'right' | 'justify';
    decoration?:string;
  }